import React from 'react'
import Menu from '../component/Menu';
import Header from '../component/Header';
import { Getintouch } from '../component/Getintouch';
import { Whyus } from '../component/Whyus';
import { Weserve } from '../component/Weserve';
//import { Whowr } from './component/Whowr';
//import { Wherewd } from './component/Wherewd';
import { ArrowSection } from '../component/ArrowSection';
import { Helmet } from 'react-helmet';
import FooterNew from '../component/FooterNew';
import AiCore from '../component/AiCore';

const Home = ({setBlank}) => {
  return (
    <>
     <Helmet>
      <title>AI-Powered Consulting, Advisory & Intelligence | Preferred Square</title>
      <meta property="og:title" content="AI-Powered Consulting, Advisory & Intelligence | Preferred Square" />
      <meta name='og:description' content='Preferred Square delivers AI, data analytics, consulting, investment advisory, and CFO services to corporates, asset managers and investors'/>
      <meta name='keywords' content=''/>
    </Helmet>
      <Menu setBlank={setBlank} />
      <Header />
      <ArrowSection setBlank={setBlank} />
      <AiCore setBlank={setBlank} />
      <Weserve setBlank={setBlank} />
      <Whyus />
      <Getintouch />
      <FooterNew setBlank={setBlank} />
    </>
  )
}

export default Home